/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $StaffSurveyCategory = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        name: {
    type: 'string',
    isRequired: true,
},
        slug: {
    type: 'string',
    isRequired: true,
},
        createdAt: {
    type: 'string',
    isRequired: true,
    format: 'date-time',
},
    },
};